import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Header from "./Header";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isSnapFooterPage = pathname.startsWith('/it');

  React.useEffect(() => {
    document.title = t('title.main');
  }, [t]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">{children}</main>
      {/* IT 풀스냅 페이지: 푸터는 스냅 대상에서 제외해 스크롤로 볼 수 있게 함 */}
      <div className={isSnapFooterPage ? 'it-footer-outside-snap' : undefined}>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
